export default {
    alertRecord: {},
}
